import React from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { getDataLayer } from 'app/selectors/AnalyticsSelector';
import DataLayer from './DataLayer';

export class DataLayerContainer extends React.PureComponent {
  render() {
    return <DataLayer {...this.props} />;
  }
}

DataLayerContainer.propTypes = {
  dataLayer: ImmutablePropTypes.map.isRequired
};

const mapStateToProps = state => ({
  dataLayer: getDataLayer(state)
});

export default connect(mapStateToProps)(DataLayerContainer);
